import React from 'react';
import { getFallbackIcon } from './iconFallback.map';
import { Icon } from '../../lib/Icon/Icon';

interface Props {
  name: string;
  className?: string;
  color?: string;
  size?: number;
}

// TODO: rethink if this is the best flag,
// perhaps CMS should pass a flag to react?
const isCmsContext = () => process.env.NODE_ENV === 'production';

/**
 * Cms icon component which renders a simple tag with class name in Cms Context
 * and an Icon component in other components.
 * If unable to get fallback icon it will render icon name.
 */
export function CmsIcon({ name: icon, className, color, size }: Props) {
  if (isCmsContext()) {
    return <i className={`${icon} ${className}`} />;
  }

  const fallbackIconName = getFallbackIcon(icon);

  if (fallbackIconName) {
    return <Icon className={className} name={fallbackIconName} color={color} size={size} />;
  }

  return <span className={className}>{icon}</span>;
}
